<template>
  <!-- 物件グループマスタ -->
  <v-form ref="p4Form" v-model="p4Form" lazy-validation>
    <v-container>
      <v-card class="select1" flat>
        <v-row>
          <v-col cols="2">
            <div class="wuj">物件グループ名</div>
          </v-col>
          <v-col cols="3">
            <ryou-select
              v-model="selectGroup"
              :value="selectGroup"
              :items="buildGroupItems"
              :itemText="'code_text'"
              :itemValue="'code_value'"
            >
            </ryou-select>
          </v-col>
          <v-col cols="2" v-show="showbtn" v-if="addFlg">
            <ryou-blue-btn
              :label="'新規追加'"
              :handlerClick="groupHandlerAdd"
            ></ryou-blue-btn>
          </v-col>
        </v-row>
      </v-card>
      <v-card flat>
        <v-row>
          <v-col cols="1">
            <div class="titleText">物件一覧</div>
          </v-col>
        </v-row>
        <!-- 2024.11.29 kouta.noborisaka 三井化学（市原工場）:絞り込みでEnterキー入力時にサブミット実行しないように「@submit.prevent」を追加 -->
        <v-form
          ref="tableForm"
          v-model="tableForm"
          lazy-validation
          @submit.prevent
        >
          <ryou-table
            ref="ryouTable"
            :rowKey="rowKey"
            :headers="headers"
            :queryParams="queryParam"
            :url="url"
            :businessKey="businessKey"
            :dummy="false"
            :needSearch="true"
            :height="height"
          >
            <v-row slot="filterContainer">
              <v-col class="proAddBtn" cols="12" v-if="addFlg">
                <ryou-blue-btn
                  :label="'新規追加'"
                  :handlerClick="buildingHandlerAdd"
                  :disabled="disBuildAdd"
                  :dark="darkCtrl"
                >
                </ryou-blue-btn>
              </v-col>
            </v-row>
          </ryou-table>
        </v-form>
      </v-card>
      <MasterPropertyDialog
        ref="properytModalForm"
        @ok="propertyFormOk"
        :url="url"
        :buildGroupItems="buildGroupItems"
      >
      </MasterPropertyDialog>
      <MasterBuildGroupDialog
        ref="BuildModalForm"
        @ok="BuildFormOk"
        :loadFlag="loadFlag"
      >
      </MasterBuildGroupDialog>
    </v-container>
  </v-form>
</template>

<script>
import RyouTable from "@/components/table/RyouTable.vue";
import RyouSelect from "@/components/formInput/RyouSelect.vue";
import RyouBlueBtn from "@/components/formInput/RyouBlueBtn.vue";
import MasterPropertyDialog from "./modules/MasterPropertyDialog.vue";
import MasterBuildGroupDialog from "./modules/MasterBuildGroupDialog.vue";
import { RyouTableMixins } from "@/mixins/RyouTableMixins";
export default {
  name: "MasterProperty",
  mixins: [RyouTableMixins],
  components: {
    RyouSelect,
    RyouBlueBtn,
    MasterPropertyDialog,
    MasterBuildGroupDialog,
    RyouTable,
  },
  mounted() {
    this.$refs.ryouTable.$on("doHandleBtn", this.masterRoomBtn);
    this.$refs.ryouTable.$on("doLinkEdit", this.linkBuildingEdit);
  },
  data() {
    return {
      loadFlag: false,
      p4Form: true,
      selectGroup: "",
      buildGroupItems: [],
      tableForm: true,
      disBuildAdd: true,
      addFlg: false,
      darkCtrl: false,
      rowKey: "rowIndex",
      businessKey: "building_id",
      height: 600,
      headers: [
        {
          text: "",
          value: "build_group_id",
          width: "0.1%",
          type: "hidden",
          sortable: false,
          groupable: false,
          filter: this.groupFilter,
        },
        {
          text: "No",
          value: "building_id",
          width: "5%",
          sortable: true,
          groupable: false,
        },
        {
          text: "物件名",
          value: "building_name",
          type: "link",
          width: "17%",
          sortable: true,
          groupable: false,
        },
        {
          text: "広さ",
          value: "building_breadth_tubo_flg",
          width: "8%",
          sortable: true,
          groupable: false,
        },
        {
          text: "建築年月日",
          value: "building_const_date",
          width: "10%",
          sortable: true,
          groupable: false,
        },
        {
          text: "築年数",
          class: "blue lighten-2 title",
          value: "building_age",
          align: "right",
          width: "8%",
          sortable: true,
          groupable: false,
        },
        {
          text: "部屋数",
          class: "blue lighten-2 title",
          value: "room_counts",
          align: "right",
          width: "8%",
          sortable: true,
          groupable: false,
        },
        {
          text: "住所",
          value: "building_address",
          width: "18%",
          sortable: true,
          groupable: false,
        },
        {
          text: "備考",
          value: "remark",
          width: "18%",
          groupable: false,
        },
        {
          text: "部屋情報",
          class: "blue lighten-2 title",
          value: "roomJohoBtn",
          type: "btn",
          align: "center",
          width: "8%",
          sortable: false,
          groupable: false,
        },
      ],
      url: {
        list:
          "/masterProperty/buildingInfoListGet?userId=" +
          this.$store.getters.getUserId +
          "&userClass=" +
          this.$store.getters.getUserClass,
        update: "/masterProperty/buildingUpdate",
        add: "/masterProperty/buildingInsert",
      },
    };
  },
  created() {
    this.buildGroupList();
  },
  methods: {
    //物件グループ名
    buildGroupList() {
      this.getRequest(
        "/masterProperty/buildGroupNameGet",
        null,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          //物件グループの初期値セット
          if (this.$store.getters.getBuilGroupId != null) {
            this.buildGroupItems = data.result.filter(
              (valueData) =>
                valueData.code_value === this.$store.getters.getBuilGroupId
            );
            //ログインユーザのユーザクラスが1(総務)出ない場合はログインユーザの物件グループIDをセット
            this.selectGroup = this.$store.getters.getBuilGroupId;
          } else {
            this.buildGroupItems = data.result;
            //空要素の追加
            this.buildGroupItems.push(this.selectGroup);
          }
        }
      });
      setTimeout(() => {}, 100);
    },
    //物件グループ新規追加
    groupHandlerAdd() {
      if (this.selectGroup != "" && this.selectGroup != null) {
        let params = {
          build_group_id: this.selectGroup,
        };
        this.getRequest(
          "/masterProperty/buildingIdCheckGet",
          params,
          this.$store.getters.getUserToken
        ).then((data) => {
          if (data.result.length == 0) {
            this.loadFlag = true; //ボタン表示
          } else {
            this.loadFlag = false; //ボタン表示しない
          }
        });
        this.$refs.BuildModalForm.edit(this.selectGroup);
      } else {
        this.loadFlag = false;
        this.$refs.BuildModalForm.add();
      }
    },
    //物件グループ名コンボボックス更新
    BuildFormOk() {
      this.buildGroupList();
      this.selectGroup = "";
    },
    //物件新規追加
    buildingHandlerAdd() {
      this.$refs.properytModalForm.add(this.selectGroup);
    },
    //物件名-->修正
    linkBuildingEdit(item) {
      this.$refs.properytModalForm.edit(item.building_id);
    },
    //物件一覧グリッド更新
    propertyFormOk() {
      this.$refs.ryouTable.loadData();
    },
    //物件グループ選択
    groupFilter(value) {
      if (!this.selectGroup) {
        return true;
      }
      return value.toLowerCase().includes(this.selectGroup.toLowerCase());
    },
    //部屋紐づけ-->部屋マスタ画面遷移
    masterRoomBtn(item) {
      this.$router.push({
        path: "/master/MasterRoom",
        name: "部屋マスタ",
        params: {
          building_id: item.building_id,
        },
      });
    },
  },
  watch: {
    // 物件グループ選択
    selectGroup(value) {
      if (value != null && value != "") {
        this.disBuildAdd = false;
        this.darkCtrl = true;
      } else {
        this.disBuildAdd = true;
        this.darkCtrl = false;
      }
    },
  },
  computed: {
    showbtn() {
      if (this.$store.getters.getUserClass == "1") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style>
.select1 {
  padding-left: 10px;
  padding-top: 20px;
}

.wuj {
  font-weight: 600;
  font-size: 19px;
  padding-top: 8px;
  padding-left: 5px;
}

.titleText {
  font-weight: 600;
  font-size: 19px;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 15px;
}

.proAddBtn {
  padding-top: 23px;
  padding-right: 60px;
  text-align: right;
}
</style>
